import api from "../services/api";


export const getAllVideos = async () => {
  const response = await api.get("/Video");
  return response.data;
};

export const getVideoById = async (id) => {
  console.log("Fetching video from URL:", `/Video/${id}`);
  const response = await api.get(`/Video/${id}`);
  return response.data;
};

export const createVideo = async (video) => {
  const response = await api.post("/Video", video);
  return response.data;
};

export const updateVideo = async (id, video) => {
  const response = await api.put(`/Video/${id}`, video);
  return response.data;
};

export const deleteVideo = async (id) => {
  const response = await api.delete(`/Video/${id}`);
  return response.data;
};



